import type { PlanUsage } from "@/common/types/planUsage";
import axiosClient from "@/lib/axios/axiosClient";

export const getAvailableMinutes = async (
  userId: number
): Promise<PlanUsage> => {
  const response = await axiosClient.post<PlanUsage>(`/get-available-minutes`, {
    userId,
  });

  return response.data;
};
